import { client } from "../../infrastructure/graphql/client";
import { GET_TROUBLESHOOT_BY_DATE_AND_VM_ID } from "../../infrastructure/graphql/troubleshootQueries";

export class TroubleshootService {
  async getTroubleshootByDateAndVmId(date, vmId) {
    try {
      const result = await client.query({
        query: GET_TROUBLESHOOT_BY_DATE_AND_VM_ID,
        variables: { date, vmId: parseInt(vmId) },
        fetchPolicy: "network-only",
      });

      const troubleshootData = result.data?.getTroubleshootByDateAndVmId;

      if (troubleshootData && troubleshootData.length > 0) {
        return {
          success: true,
          data: troubleshootData,
        };
      }

      return {
        success: false,
        message: "No troubleshoot data found",
        data: [],
      };
    } catch (error) {
      console.error("Get troubleshoot error:", error);
      const errorMessage =
        error.graphQLErrors?.[0]?.message || "Failed to fetch troubleshoot data";
      return { success: false, message: errorMessage, data: [] };
    }
  }
}